<template>
  <button class="editing-toggle icon" :class="{active: draggingCategories}" @click="toggleDraggingCategories">
    <v-icon name="list"/>
  </button>
</template>
<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'editing-categories-toggle',
    computed: {
      ...mapState(['draggingCategories'])
    },
    methods: {
      ...mapActions(['toggleDraggingCategories'])
    },
  }
</script>
<style scoped lang="sass">
  .editing-toggle
    min-width: unset
    transition: $transition-quick
    transform: scaleX(-1)

    &.active
      background-color: $blue
      color: $white
      border-color: transparent
</style>
